import React, { useEffect, useState } from 'react';

import { useRequestCashAppPayment } from 'features/payment/hooks/use-request-cash-app-payment.web';
import { paymentErrorType } from 'features/payment/types';

import { ICashAppButton } from '../types';

import { CashAppStyledButton } from './cashapp-button.styled';
import { CashappError } from './cashapp-error';

export const CashAppButton: React.FC<ICashAppButton> = ({
  serverOrder,
  onResult,
  onError,
  showLoading,
  tipAmount,
}: ICashAppButton) => {
  const cartTotalCents = serverOrder?.cart?.totalCents || 0;
  const totalCents = cartTotalCents + (tipAmount || 0);
  const [isResultNotified, setIsResultNotified] = useState(false);
  const { isLoading, data, error, requestPayment } = useRequestCashAppPayment({
    cashapp: {
      total: totalCents,
      tax: 0,
      tip: tipAmount || 0,
    },
  });

  useEffect(() => {
    if (data && data.cashappDetails && !isResultNotified) {
      onResult(data.cashappDetails);
      setIsResultNotified(true);
    }
  }, [data, onResult, isResultNotified]);

  useEffect(() => {
    if (error === paymentErrorType.cashAppGeneric) {
      setIsResultNotified(true);
      onError(new Error('Cash App payment failed'));
    }
  }, [error, onError]);

  return (
    <>
      {error === paymentErrorType.cashAppDeclined && <CashappError />}
      <CashAppStyledButton
        isLoading={showLoading || isLoading}
        onPress={() => {
          setIsResultNotified(false);
          requestPayment();
        }}
      ></CashAppStyledButton>
    </>
  );
};
